<template>
  <div class="details">
    <el-dialog
        :before-close="handleClose"
        :title="details.title"
        :visible.sync="details.dialogVisible"
        width="70%">
      <div>
        <el-card>
          <el-form label-position="right" label-width="120px">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="姓名：">
                  {{ details.data.title }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申请单位：">
                  {{ details.data.dwmc }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申请材料：">
                  <el-image
                      :preview-src-list="[details.data.material]"
                      :src="details.data.material"
                      style="width: 100px; height: 100px">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline" style="font-size: 24px"></i>
                    </div>
                  </el-image>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注：">
                  {{ details.data.remark }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申请时间：">
                  {{ details.data.sqsj }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态：">
                  <span v-if="details.data.status==1">审核通过</span>
                  <span v-else-if="details.data.status==2">审核不通过</span>
                  <span v-else>未审核</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="审核人：">
                  {{ details.data.reviewer }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="审核意见：">
                  {{ details.data.reviewtext }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="审核时间：">
                  {{ details.data.reviewtime }}
                </el-form-item>
              </el-col>

            </el-row>
          </el-form>

        </el-card>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "bgView",
  props: ['details'],
  data() {
    return {
      srcList: [],
      dialogVisible: false
    }
  },

  mounted() {
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
  }
}
</script>

<style lang="scss" scoped>
.details {
  /deep/ .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-col {
      margin-bottom: 10px;
    }
  }

  /deep/ .el-image {
    .image-slot {
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f5f7fa;
      color: #909399;

    }
  }
}

</style>